module.exports = __webpack_public_path__ + "img/shape-6-mobile@2x.17e20e02.png";